import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2p17ktuxx3: FaireBrandEntity = {
  token: "b_2p17ktuxx3",
  type: "brand",
  name: "Euphoria Chocolate Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/71a88751d16c1038b7be83105da5a01bdbd5c1d68413ea6e7bfb3a993c7e434b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2665e7566232e1c04a56c4db2d8fc65c8524156aa1f7c353f100ca8b092b54a0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/71a88751d16c1038b7be83105da5a01bdbd5c1d68413ea6e7bfb3a993c7e434b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2665e7566232e1c04a56c4db2d8fc65c8524156aa1f7c353f100ca8b092b54a0.png",
  location: "Eugene, OR, USA",
  minimumOrderDollars: 69,
  rating: 4.8,
  reviewCount: 8,
  isInsider: true,
  description:
    'Euphoria Chocolate Company has been delighting chocolate lovers in the Pacific Northwest with hand dipped truffles, artisan chocolates and confectioneries since 1980.  Euphoria Chocolate Company has three retail locations and a production facility located in Eugene, Oregon. \n\nWe are dedicated to offering artisan confections made of the highest quality ingredients. Euphoria chocolatiers handcraft small batch creations using the locally-sourced flavors. Oregon wine, beer, and spirits feature prominently in our product offerings.  As a locally owned small business, we value relationships with our clients and partners.\n\nOur hand dipped truffles have won acclaim with Chocolatier, Success, various candy industry magazines and gourmet guides such as "Food Finds" and "The Chocolate Lover\'s Guide to the Pacific Northwest." We are proud to be a regular on the Eugene Best List.',
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:35.812Z",
    importedBy: "entity-db-cli",
  },
};
